export class JsonPath {
    constructor(obj) {
        this.obj = obj;
    }
    update(path, setter) {
        const properties = path.split('.');
        let refs = [{
                value: this.obj, setter: (a) => {
                }
            }];
        while (properties.length > 0) {
            const current = properties.shift();
            let nextRefs = [];
            while (refs.length > 0) {
                const ref = refs.pop();
                const value = ref.value;
                if (Array.isArray(value)) {
                    if (Number.isFinite(+current)) {
                        if (current in value) {
                            nextRefs.push({
                                value: value[current], setter: (v) => {
                                    value[current] = v;
                                }
                            });
                        }
                    }
                    else {
                        for (let element of value) {
                            if (current in element) {
                                nextRefs.push({
                                    value: element[current], setter: (v) => {
                                        element[current] = v;
                                    }
                                });
                            }
                        }
                    }
                }
                else {
                    if (current in value) {
                        nextRefs.push({ value: value[current], setter: (v) => value[current] = v });
                    }
                }
            }
            refs = nextRefs;
        }
        for (const ref of refs) {
            const v = ref.value;
            if (Array.isArray(v)) {
                for (let i = 0; i < v.length; i++) {
                    const value = v[i];
                    v[i] = setter(value);
                }
            }
            else {
                const newValue = setter(ref.value);
                ref.setter(newValue);
            }
        }
    }
}
//# sourceMappingURL=JsonPath.js.map